<ng-container *transloco="let t; prefix: 'orders.newCustomer'">
  @if (dialogRef) {
    <div mat-dialog-title class="dialog-header">
      <span class="title-large">{{ t('filtersTitle') }}</span>
      <button matIconButton type="button" [attr.aria-label]="t('closeFilters')" (click)="dialogRef.close()">
        <i class="fa-regular fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  }

  <form class="filters-form" [class.filters-form--dialog]="!!dialogRef" [formGroup]="form" (ngSubmit)="apply()">
    <div class="filter-fields">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('municipality') }}</mat-label>
        <mat-select formControlName="comune">
          @for (comune of comuni(); track comune) {
            <mat-option [value]="comune">{{ comune }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('province') }}</mat-label>
        <mat-select formControlName="provincia">
          @for (provincia of province(); track provincia) {
            <mat-option [value]="provincia">{{ provincia }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-actions">
      <button matButton="filled" type="submit">{{ t('applyFilters') }}</button>
      <button matButton="outlined" type="button" [disabled]="!hasValues" (click)="clear()">{{ t('clearFilters') }}</button>
    </div>
  </form>
</ng-container>
